import { useContext } from "react";
import useUserProfile from "../useUserProfile";
import FeatureFlagsContext from "./FeatureFlagsContext";

export interface UseFeatureFlagsResult {
  isEnabled: (key: string) => boolean;
  loading: boolean;
}

/** Hook that provides access to active feature flags for the current user. */
export function useFeatureFlags(): UseFeatureFlagsResult {
  const contextFlags = useContext(FeatureFlagsContext);
  const { featureFlags, loading } = useUserProfile({ skip: contextFlags !== null });

  const flags = contextFlags ?? featureFlags;

  return {
    isEnabled: (key: string) => flags.get(key) ?? false,
    loading: contextFlags !== null ? false : loading,
  };
}
